import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgeModule } from '@tylertech/forge-angular';
import { ForgeInternalModule } from '@tylertech/forge-angular-internal'
import { IconRegistry } from '@tylertech/forge';
import * as standard from '@tylertech/tyler-icons/standard';
import * as extended from '@tylertech/tyler-icons/extended';
import * as custom from '@tylertech/tyler-icons/custom';

IconRegistry.define([
  extended.tylIconAlert,
  standard.tylIconWarning,
  standard.tylIconBrightness3,
  standard.tylIconCloudDownload,
  standard.tylIconDevices,
  standard.tylIconFolder,
  standard.tylIconGroups,
  standard.tylIconInfo,
  standard.tylIconClose,
  standard.tylIconAdd,
  standard.tylIconSearch,
  standard.tylIconWbSunny,
  standard.tylIconKeyboardArrowRight,
  standard.tylIconLocationCity,
  standard.tylIconPhonelink,
  standard.tylIconPerson,
  standard.tylIconArrowBack,
  standard.tylIconPrint,
  standard.tylIconSettings,
  standard.tylIconImage,
  standard.tylIconImageSearch,
  standard.tylIconFactCheck,
  standard.tylIconContentCopy,
  standard.tylIconEdit,
  standard.tylIconChevronRight,
  standard.tylIconMoreVert,
  standard.tylIconAccountTree,
  standard.tylIconApi,
  standard.tylIconPersonSearch,
  standard.tylIconSort,
  standard.tylIconColorLens,
  standard.tylIconFileUpload,
  standard.tylIconRemoveCircle,
  standard.tylIconCompareArrows,
  standard.tylIconDelete,
  standard.tylIconKeyboardArrowDown,
  standard.tylIconKeyboardArrowUp,
  standard.tylIconExpandMore,
  standard.tylIconExpandLess,
  standard.tylIconArrowForward,
  standard.tylIconCloudUpload,
  standard.tylIconVisibilityOff,
  standard.tylIconDragIndicator,
  standard.tylIconDragHandle,
  standard.tylIconNotifications,
  standard.tylIconFilterAlt,

  extended.tylIconArrowUpDropCircle,
  extended.tylIconImageMultipleOutline,
  extended.tylIconEmailOutline,
  extended.tylIconEmailOpenOutline,
  extended.tylIconBell,
  extended.tylIconBookOpenVariant,
  extended.tylIconDotsVertical,
  extended.tylIconThemeLightDark,
  extended.tylIconTextSearch,

  custom.tylIconTylerTalkingTLogo

]);

export const FORGE_TABLE_ROW_SELECTED_CLASS = 'forge-table-body__row--selected';

export class ForgeImageUrls {
  public static readonly Error403: string = 'https://cdn.forge.tylertech.com/v1/images/spot-hero/403-error-spot-hero.svg';
  public static readonly Error403_2: string = 'https://cdn.forge.tylertech.com/v1/images/spot-hero/403-error-2-spot-hero.svg';
  public static readonly Error404: string = 'https://cdn.forge.tylertech.com/v1/images/spot-hero/404-error-spot-hero.svg';
  public static readonly Error500: string = 'https://cdn.forge.tylertech.com/v1/images/spot-hero/500-error-spot-hero.svg';
  public static readonly Error500_2: string = 'https://cdn.forge.tylertech.com/v1/images/spot-hero/500-error-2-spot-hero.svg';
  public static readonly OfflineError: string = 'https://cdn.forge.tylertech.com/v1/images/spot-hero/offline-spot-hero.svg';
  public static readonly NoImageAvailable: string = 'https://cdn.forge.tylertech.com/v1/images/spot/no-image-available-primary-spot.svg';
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ForgeModule,
    ForgeInternalModule
  ],
  exports: [
    ForgeModule,
    ForgeInternalModule
  ]
})
export class ForgeProxyModule {
}